import React, { Component, Fragment } from "react";

class Select extends Component {
  render() {
    const {
      options, //OPTIONS
      name, //INPUT NAME ( NOTE: it is also used as an key for changing state )
      value, //VALUE
      onSelect, //ONCHANGE
      disabled
    } = this.props;

    return (
      <select
        className="form-control select-height customized-height-inputform"
        name={name}
        value={value}
        onChange={e => onSelect(name, e.target.value)}
        disabled={disabled}
      >
        <option value="">select</option>
        {options !== undefined &&
          Array.isArray(options) &&
          options.map(data => <option value={data.value}>{data.label}</option>)}
      </select>
    );
  }
}

Select.defaultProps = {
  options: [],
  value: "",
  disabled: false
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/Select/Select.js